import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  AgreementAreaModule,
  ButtonModule,
  CheckboxModule,
  DebugLanguageSwitchModule,
  IndicatorPopupModule,
  InputModule,
  RadiobuttonModule,
  RangeSliderModule,
  SelectDateYmModule,
  SelectModule,
  TextTooltipModule,
  ToggleModule,
} from '@lib/components';
import { ThrottleClickDirectiveModule, TooltipDirectiveModule } from '@lib/directives';
import { PopupIndicatorPipeModule } from '@lib/pipes';
import { DialogDisplayServiceModule } from '@lib/services';
import { TranslateModule } from '@ngx-translate/core';
import { StaticMsgModule } from '../../../lib/pipes/static-msg/static-msg.module';

import { ServiceRequestPaymentInputPresComponent } from './service-request-payment-input-pres.component';
import { ServiceRequestPaymentInputNotificationModule } from '../sub-components/service-request-payment-input-notification/service-request-payment-input-notification.module';
import { ServiceRequestPaymentInputCreditCardModule } from '../sub-components/service-request-payment-input-credit-card/service-request-payment-input-credit-card.module';
import { ServiceRequestPaymentInputPaymentMethodsModule } from '../sub-components/service-request-payment-input-payment-methods/service-request-payment-input-payment-methods.module';
import { ServiceRequestPaymentInputPaymentAmountModule } from '../sub-components/service-request-payment-input-payment-amount/service-request-payment-input-payment-amount.module';

@NgModule({
  declarations: [ServiceRequestPaymentInputPresComponent],
  exports: [ServiceRequestPaymentInputPresComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ButtonModule,
    InputModule,
    FormsModule,
    ReactiveFormsModule,
    RadiobuttonModule,
    ToggleModule,
    TextTooltipModule,
    TooltipDirectiveModule,
    CheckboxModule,
    SelectModule,
    RangeSliderModule,
    OverlayModule,
    SelectDateYmModule,
    DebugLanguageSwitchModule,
    IndicatorPopupModule,
    PopupIndicatorPipeModule,
    DialogDisplayServiceModule,
    ThrottleClickDirectiveModule,
    AgreementAreaModule,
    StaticMsgModule,
    ServiceRequestPaymentInputCreditCardModule,
    ServiceRequestPaymentInputNotificationModule,
    ServiceRequestPaymentInputPaymentMethodsModule,
    ServiceRequestPaymentInputPaymentAmountModule,
  ],
})
export class ServiceRequestPaymentInputPresModule {}
